var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#13D16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0346 36.0667C40.2444 34.9766 41.7647 32.7009 41.7647 30.0702C41.7647 26.3796 38.7729 23.3878 35.0823 23.3878C31.3918 23.3878 28.4 26.3796 28.4 30.0702C28.4 32.7009 29.9202 34.9766 32.13 36.0667C26.6349 36.6418 22.5529 38.7866 22.5529 41.3445C22.5529 44.3431 28.1625 46.7739 35.0823 46.7739C42.0021 46.7739 47.6117 44.3431 47.6117 41.3445C47.6117 38.7866 43.5297 36.6418 38.0346 36.0667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar_default.4130e4737eb75177bc1f5e4194cd421e.svg";
export { ForwardRef as ReactComponent };